var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0837 3.73925L10.2612 2.91675L7.00033 6.17758L3.73949 2.91675L2.91699 3.73925L6.17783 7.00008L2.91699 10.2609L3.73949 11.0834L7.00033 7.82258L10.2612 11.0834L11.0837 10.2609L7.82283 7.00008L11.0837 3.73925Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose24Px);
export default __webpack_public_path__ + "static/media/close_24px.781ced303f148e16a6fea4f5320d7d86.svg";
export { ForwardRef as ReactComponent };